module.exports = __webpack_public_path__ + "static/img/casino-pc-thum03.2cc1fd8.png";